<template>
    <v-container fluid >
        <Formulario :getParams="this.params"></Formulario>
    </v-container>
</template>

<script>
const Formulario = () => import("./components/Formulario.vue");
import Auth from "@/services/auth";
export default {
    name: "ParticipantesEstudiantesNuevo",
    data() {
        return {
            permisos: [],
            params: {
                persona_id: null,
                cat_tipo_persona_id: 3,
                permisos: [],
            }
        }
    },
    components: {
        Formulario
    },
    methods: {
        regresar() {
            this.$router.go(-1)
        }
    },
    created() {
        Auth.checkPermisos("/participantes/estudiantes").then((res) => {
            this.permisos = res;

            if(!this.permisos[2]) {
                this.regresar();
            }
            this.params.permisos = this.permisos;
        });
    }
}
</script>

<style>

</style>
